<template>
  <div class="tree-container">
    <ul class="tree">
      <TreeViewNode 
        v-for="node in filteredNodes" 
        :key="node.path" 
        :node="node" 
        :expand-all="expandAll"
        @select="onSelect"
      />
    </ul>
  </div>
  
</template>

<script setup lang="ts">
// Component name for export
defineOptions({
  name: 'TreeView'
})
import { computed } from 'vue'
import TreeViewNode from './TreeViewNode.vue'

export interface TreeNodeItem {
  name: string
  path: string
  type: 'dir' | 'file'
  children?: TreeNodeItem[]
}

const props = defineProps<{ nodes: TreeNodeItem[]; expandAll?: boolean }>()
const emit = defineEmits<{
  (e: 'select', node: TreeNodeItem): void
}>()

const filteredNodes = computed(() =>
  (props.nodes || []).filter(n => n.name !== 'manifest.json')
)

const onSelect = (node: TreeNodeItem) => emit('select', node)
const expandAll = computed(() => !!props.expandAll)
</script>

<style scoped>
.tree-container {
  height: 62vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem;
  border: 1px solid var(--lwsa-gray-200);
  border-radius: 0.75rem;
}
.tree {
  list-style: none;
  padding-left: 0.25rem;
  margin: 0;
}
</style>


